import React, { useState } from 'react';
import { MagnifyingGlassIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import {
  IconWrapper,
  StyledInputText,
} from '../styles/CommunicationSearch.styles';

export const CommunicationSearch = ({ searchTerm, handleChange }) => {
  const [isInputFocused, setIsInputFocused] = useState(false);
  const Icon = () => (
    <IconWrapper isInputFocused={isInputFocused}>
      <MagnifyingGlassIcon height="16px" width="16px" />
    </IconWrapper>
  );

  const handleInputFocus = () => {
    setIsInputFocused(prev => !prev);
  };

  return (
    <Box mb={3}>
      <StyledInputText
        id="text-history-search"
        bgType="primary"
        placeholder="Phone Number"
        type="text"
        value={searchTerm}
        onChange={handleChange}
        shouldDisplayClearButton={false}
        shouldDisplayErrorIcon={false}
        IconLeft={Icon}
        onFocus={handleInputFocus}
        onBlur={handleInputFocus}
      />
    </Box>
  );
};
